module.exports = __webpack_public_path__ + "static/media/email.73416f31.svg";